'use strict';

export const PREFIX = 'aon';

export const BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl', 'dx', 'tx'];
